import { useCallback, useEffect, useRef, useState } from 'react';

import { getLatestPostSaleOffer as getLatestPostSaleOfferAPI } from 'PrivateAPI';

import { captureExceptionWithTeam } from 'Utilities/captureException/captureExceptionWithTeam';
import { TEAM } from 'Utilities/constants';

import { LatestPostSaleOffer } from '../../../containers/app/payments/Payments.types';

const include = 'dealerPaymentCompleted,dealerName';

export const useGetLatestPostSaleOffer = () => {
  const [data, setData] = useState<LatestPostSaleOffer<{include: StringToUnion<typeof include> }>>();
  const [isFetched, setIsFetched] = useState<boolean>(false);
  const cancelled = useRef(false);

  const resolve = useCallback((newData: typeof data) => {
    if (cancelled.current) {
      return;
    }

    setData(newData);
  }, []);

  const getLatestPostSaleOffer = useCallback(async (dpEnquiryId: number) => {
    try {
      const response: ApiResponseForJsend<NonNullable<typeof data>> = (
        await getLatestPostSaleOfferAPI(dpEnquiryId, { include }, undefined)
      );

      if (response.status === 'success') {
        resolve(response.data);
      }
    } catch (err) {
      resolve(undefined);

      if (err && (err as { message: string }).message === 'motorway.payments.latest_post_sale_offer_not_found') {
        return;
      }

      captureExceptionWithTeam(
        err,
        TEAM.PAYMENTS_FE,
        {
          extra: {
            dpEnquiryId,
          },
          tags: {
            fetch: 'useLatestPostSaleOffer',
          },
        },
      );
    } finally {
      setIsFetched(true);
    }
  }, [resolve]);

  useEffect(() => () => {
    cancelled.current = true;
  }, []);

  return {
    data,
    getLatestPostSaleOffer,
    isFetched,
  };
};
